import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateAgo',
  pure: true,
  standalone: true
})
export class DateAgoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      // Use moment().diff() so the comparison happens in UTC milliseconds
      // internally — avoids the midnight-rollover bug caused by converting a
      // UTC timestamp to a local-time string and then re-parsing it with
      // new Date(), which could produce a date-stamp one day ahead of "now".
      const seconds = Math.floor(moment().diff(moment(value), 'seconds'));
      if (seconds < 29) // less than 30 seconds ago will show as 'Just now'
        return 'Just now';
      const intervals: any = {
        'year': 31536000,
        'month': 2592000,
        'week': 604800,
        'day': 86400,
        'hour': 3600,
        'minute': 60,
        'second': 1
      };
      for (const i in intervals) {
        const counter = Math.floor(seconds / intervals[i]);
        if (counter > 0) {
          return counter === 1 ? `${counter} ${i} ago` : `${counter} ${i}s ago`;
        }
      }
    }
    return value;
  }

}
